import React, { useState, useEffect } from 'react';
import axios from "axios";

export default function DrafterInfo({ drafterId }) {
    const [drafterInfo, setDrafterInfo] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    async function fetchDrafterById(drafterId) {
        try {
            const response = await axios.get(`${process.env.REACT_APP_LAWS_BACKEND_HOST}/legislators/v1/staffMembers/${drafterId}`);
            return response.data;
        } catch (error) {
            console.error("Error fetching bill draft drafter data: ", error);
            throw error;
        }
    }

    useEffect(() => {
        async function loadDrafterInfo() {
            try {
                const data = await fetchDrafterById(drafterId);
                setDrafterInfo(data);
                setLoading(false);
            } catch (err) {
                setError(err);
                setLoading(false);
            }
        }

        loadDrafterInfo();
    }, [drafterId]);

    if (loading) return <span>Loading...</span>;
    if (error) return <span>Error: {error.message}</span>;
    if (!drafterInfo) return <span>{drafterId}</span>;

    return <>{drafterInfo.lastName}, {drafterInfo.firstName}</>
}